import React from 'react'

export default () => {
  return (
    <div>
        <h2>Based on your results, it seems like the dizziness may be occurring due to   <strong>Central Acute Vestibular Syndrome</strong> </h2>
        <p>Acute vestibular syndrome (AVS) is most often characterized by sudden onset of vertigo, nausea or vomiting, and gait unsteadiness along with head-motion intolerance and nystagmus, which can last days to weeks.</p>
        <p>This type of dizziness is often indicative of underlying health conditions, so it’s important to speak with a healthcare provider to get an official diagnosis and treatment plan</p>
    </div>
  )
}
